import { render } from "./Contact.vue?vue&type=template&id=18167d7b&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=18167d7b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18167d7b"

export default script